var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        {
          staticClass: "mx-5 mt-5 mb-1 pos-card",
          staticStyle: { height: "264px" },
          attrs: { outlined: "", "rounded-lg": "", flat: "" },
        },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-sheet",
                    { staticClass: "transparent" },
                    [
                      _c("input", {
                        ref: "photo",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "file",
                          accept: "image/jpeg, image/png",
                        },
                        on: { change: _vm.getLogoPreview },
                      }),
                      _c("v-hover", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ hover }) {
                              return [
                                _c(
                                  "v-img",
                                  {
                                    staticStyle: {
                                      height: "265px",
                                      "border-radius": "10px !important",
                                    },
                                    attrs: {
                                      loading: _vm.logoPreview,
                                      src: _vm.logoPreview
                                        ? _vm.logoPreview
                                        : _vm.photo,
                                      cover: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.photo
                                          ? {
                                              key: "placeholder",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass:
                                                        "fill-height ma-0",
                                                      attrs: {
                                                        align: "center",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-progress-circular",
                                                        {
                                                          attrs: {
                                                            size: "30",
                                                            indeterminate: "",
                                                            color:
                                                              "blue lighten-4",
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    !(
                                      !!_vm.photo ||
                                      "".length ||
                                      !!_vm.logoPreview ||
                                      "".length
                                    )
                                      ? _c(
                                          "v-container",
                                          {
                                            class: {
                                              "placeholder hover-stackholder":
                                                hover,
                                            },
                                            attrs: { "fill-height": "" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "pa-0 text-center mx-auto",
                                              },
                                              [
                                                _c("img", {
                                                  class: {
                                                    "hover-stackholder-img":
                                                      hover,
                                                  },
                                                  staticStyle: {
                                                    "z-index": "0",
                                                    position: "relative",
                                                  },
                                                  attrs: {
                                                    contain: "",
                                                    height:
                                                      _vm.$route.name ===
                                                      "PosRetrieveUpdate"
                                                        ? 160
                                                        : 130,
                                                    src: require(`@/assets/backgrounds/background-${
                                                      _vm.$route.name ===
                                                      "PosRetrieveUpdate"
                                                        ? "pos"
                                                        : "branch"
                                                    }-detail.svg`),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-toolbar",
        {
          staticClass: "mx-5 mt-5",
          attrs: { color: "transparent", flat: "", height: "36" },
        },
        [
          _c(
            "v-toolbar-title",
            { staticClass: "subtitle-2 grey-500--text font-weight-bold" },
            [_vm._v("Información básica ")]
          ),
          _c("v-spacer"),
        ],
        1
      ),
      _c(
        "v-list",
        { staticClass: "px-5 transparent v-list-form-2 py-0" },
        _vm._l(_vm.itemList, function (item, index) {
          return _c(
            "div",
            { key: `${item.id}-${index}` },
            [
              item.isBtn
                ? _c(
                    "v-list-item",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "grey-500--text subtitle-2" },
                        [_vm._v(_vm._s(item.title))]
                      ),
                      _c(
                        "v-list-item-subtitle",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "grey-900" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("isClick")
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.value))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !item.title.includes("ID")
                ? _c(
                    "v-list-item",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "grey-500--text subtitle-2" },
                        [_vm._v(_vm._s(item.title))]
                      ),
                      item.title !== "Tienda"
                        ? _c(
                            "v-list-item-subtitle",
                            { staticClass: "grey-300--text body-1" },
                            [
                              item.isEditable
                                ? [
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        required: "",
                                        "single-line": "",
                                        dense: "",
                                        height: "20",
                                        maxlength: "100",
                                        "hide-details": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("update:editable", {
                                            ..._vm.editable,
                                            ...{ name: item.value },
                                          })
                                        },
                                      },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    }),
                                  ]
                                : [
                                    item.value
                                      ? [_vm._v(_vm._s(item.value))]
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 text--disabled font-italic",
                                          },
                                          [_vm._v("Sin especificar")]
                                        ),
                                  ],
                            ],
                            2
                          )
                        : item.title === "Tienda"
                        ? _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "green-500--text text-decoration-none",
                                  attrs: {
                                    to: {
                                      name: "BranchRetrieveUpdate",
                                      params: {
                                        id: item.id,
                                        ..._vm.currentParams,
                                      },
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.value) + " ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              item.isEditable
                ? _c(
                    "v-btn",
                    {
                      staticClass: "mt-1",
                      attrs: { text: "", color: "grey-900", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("save")
                        },
                      },
                    },
                    [_vm._v("Actualizar datos")]
                  )
                : item.isTooltip
                ? _c(
                    "v-list-item",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "grey-500--text subtitle-2" },
                        [_vm._v(_vm._s(item.title))]
                      ),
                      item.value
                        ? _c(
                            "v-list-item-subtitle",
                            { staticClass: "grey-300--text body-1" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    color: "grey-background",
                                    right: "",
                                    transition: "scale-transition",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass:
                                                    "grey-300--text body-1",
                                                  staticStyle: {
                                                    "justify-content": "left",
                                                  },
                                                  attrs: {
                                                    text: "",
                                                    ripple: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toClipboard(
                                                        item.value
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [_vm._v(_vm._s(item.value))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-block px-3 py-2" },
                                    [_vm._v("Copiar")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c("v-list-item-subtitle", [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 text--disabled font-italic",
                              },
                              [_vm._v("Sin especificar")]
                            ),
                          ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }